"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function xpa(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.4307 8.8845L12.3482 7.1415L10.2677 10.6852L7.85119 7.8825L8.94619 7.7415L10.0749 9.0675L11.3274 6.84825L5.81494 5.268C5.74088 5.24605 5.66234 5.244 5.58724 5.26207C5.51214 5.28014 5.44313 5.31768 5.38716 5.37091C5.33119 5.42415 5.29024 5.49119 5.26843 5.56529C5.24662 5.63939 5.24473 5.71793 5.26294 5.793L7.70494 15.6L10.3277 11.184L12.7442 13.9867L11.6492 14.1277L10.5212 12.8017L8.03869 16.9395L8.40619 18.417C8.42531 18.4919 8.46374 18.5605 8.51764 18.616C8.57154 18.6715 8.63903 18.7118 8.71339 18.7331C8.78774 18.7543 8.86637 18.7557 8.94143 18.7371C9.01649 18.7185 9.08537 18.6805 9.14119 18.627L18.6137 9.6195C18.6696 9.56651 18.7105 9.49962 18.7321 9.42567C18.7537 9.35172 18.7553 9.27336 18.7366 9.1986C18.718 9.12384 18.6799 9.05537 18.6261 9.00018C18.5724 8.94499 18.5049 8.90507 18.4307 8.8845Z", fill: color }));
}
exports["default"] = xpa;
//# sourceMappingURL=xpa.js.map